<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl">
        <DropdownButton v-if="widget.content.shared.length">
            <template v-slot:text>
                {{ $t('messages.common') }}
            </template>
            <template v-slot:content>
                <a
                    v-for="(bookmark, index) in widget.content.shared"
                    :href="bookmark.url"
                    :key="`${bookmark.url}_${index}`"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                    role="menuitem"
                >
                    {{ bookmark.title }}
                </a>
            </template>
        </DropdownButton>

        <DropdownButton v-if="widget.content.teacher.length">
            <template v-slot:text>
                {{ $t('messages.mine') }}
            </template>
            <template v-slot:content>
                <a
                    v-for="(bookmark, index) in widget.content.teacher"
                    :href="bookmark.url"
                    :key="`${bookmark.url}_${index}`"
                    class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                    role="menuitem"
                >
                    {{ bookmark.title }}
                </a>
            </template>
        </DropdownButton>
        <template v-else>
            <AppButton :href="widget.titleUrl">
                {{ $t('messages.mine') }}
            </AppButton>
        </template>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import DropdownButton from '@/components/DropdownButton.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    name: 'BookmarksWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        BaseWidget,
        DropdownButton,
        AppButton,
    },
};
</script>
